<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab lazy>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Genel Bilgiler
        </template>
        <products-product-card />
      </b-tab>
      <b-tab
        :disabled="!dataItem.id"
        lazy
      >
        <template #title>
          <feather-icon icon="DollarSignIcon" />
          Fiyatlandırma
        </template>
        <products-prices-card />
      </b-tab>
      <b-tab
        :disabled="!dataItem.id"
        lazy
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Dokümanlar
        </template>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <products-files-card />
          </b-col>
          <b-col
            v-if="userData.secret_files === '1' && controlSecretFiles"
            cols="12"
            md="12"
          >
            <products-secret-files-card />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab
        :disabled="!dataItem.id"
        lazy
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Medya Galeri
        </template>
        <media-card />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs, BTab, BRow, BCol,
} from 'bootstrap-vue'
import ProductsPricesCard from '@/views/Products/Components/PricesCard.vue'
import ProductsFilesCard from '@/views/Products/Components/DocumentsCard.vue'
import ProductsSecretFilesCard from '@/views/Products/Components/SecretDocumentsCard.vue'
import ProductsProductCard from '@/views/Products/Components/ProductCard.vue'
import MediaCard from '@/views/Products/Components/MediaCard.vue'

export default {
  name: 'ProductsItemForm',
  components: {
    ProductsSecretFilesCard,
    ProductsFilesCard,
    ProductsPricesCard,
    ProductsProductCard,
    MediaCard,
    BTabs,
    BTab,
    BRow,
    BCol,

  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
    controlSecretFiles() {
      // userData içindeki packageLimits array'inde subject'i PRODUCTS_SECRET_FILES olan elemanın limit'i 1 ise true, değilse false döndürür
      if (
        this.userData
          && Array.isArray(this.userData.packageLimits)
      ) {
        const found = this.userData.packageLimits.find(
          item => item.subject === 'PRODUCTS_SECRET_FILES',
        )
        return found && found.limit === 1
      }
      return false
    },
  },
}
</script>
